export const eventInfoTableStyle = {
  wrapper: {
    background: 'var(--default-white)',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  filterRow: {
    marginBottom: '12px',
    display: 'flex',
    gap: '16px',
    marginLeft: 'auto',
    width: 'fit-content',
  },

  search: {
    flex: 1,
    minWidth: '300px',
    position: 'relative',

    svg: {
      position: 'absolute',
      left: '10px',
      top: '8px',
    },

    '& .MuiFormControl-root .MuiInputBase-root input': {
      paddingLeft: '40px',

      '&::placeholder': {
        color: 'var(--neutral-500)',
      },
    },
    '& .MuiFormControl-root .MuiInputBase-root fieldset': {
      border: 0,
      background: 'var(--background-grey-op-50-1)',
    },
  },

  table: {
    minWidth: 650,
    tableLayout: 'fixed',
  },

  // Column order matches columnOptions: id, name, date, status, + actions
  tableHeader: {
    height: '32px',

    '& > :nth-of-type(1)': {
      width: '8%',
    },
    '& > :nth-of-type(2)': {
      width: '40%',
    },
    '& > :nth-of-type(3)': {
      width: '32%',
    },
    '& > :nth-of-type(4)': {
      width: '14%',
      textAlign: 'right',
    },
    '& > :nth-of-type(5)': {
      width: '6%',
    },
  },

  headerCellTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer',
  },

  tableBody: {
    '& .MuiTableRow-root': {
      height: '58px',
    },

    '& .MuiTableCell-root': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },

  textID: {
    fontSize: '12px',
  },

  name: {
    fontWeight: '700 !important',
    color: 'var(--neutral-900)',
  },

  dateLabel: {
    color: 'var(--neutral-300)',
    width: '37px',
    display: 'inline-block',
  },

  statusActive: {
    color: 'var(--success-600) !important',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  statusBlocked: {
    color: 'var(--error-600) !important',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  statusDefault: {
    color: 'var(--neutral-600)',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  menu: {
    '&.MuiTableCell-body': {
      padding: '0 5px',
    },
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',
    textTransform: 'capitalize',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  paginationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '40px',
    marginTop: 'auto',
  },

  modal: {
    '.MuiPaper-root': {
      maxWidth: '770px',
      padding: '48px 200px',
      width: '100%',
    },
  },

  textWrapper: {
    marginTop: '8px',
    textAlign: 'center',
  },

  description: {
    display: 'inline',
    color: 'var(--neutral-300)',
    textAlign: 'center',
  },

  descriptionBottom: {
    color: 'var(--neutral-300)',
    textAlign: 'center',
    marginTop: '16px',
  },

  bold: {
    color: 'var(--neutral-600)',
    fontWeight: '700',
    display: 'inline',
  },
};
